import axios from "fetch-api/fetch-api";
import { IActionResponse } from "../interfaces/base-response";

export function updateItemApi(sku: string, quantity: number) {
  return axios.post<IActionResponse>("/update-shopping-cart-v3", {
    sku,
    quantity,
  });
}
